import { Box } from '@mui/material';
import React from 'react';

interface LogoProps {
  size?: number | string;
  animate?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 40, animate = false }) => {
  return (
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/logo.png`}
      alt="Dietaro Logo"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        ...(animate && {
          animation: 'float 3s ease-in-out infinite',
          '@keyframes float': {
            '0%, 100%': { transform: 'translateY(0)' },
            '50%': { transform: 'translateY(-5px)' },
          },
        }),
      }}
    />
  );
};

export default Logo;
